import React, { useState, useCallback } from 'react';
import { styled, alpha } from '@mui/material/styles';
import { Typography, Grid, Accordion, AccordionSummary, AccordionDetails, Divider, Button, Paper, Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material';
import { isMobile } from 'react-device-detect';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import { Box, Pagination, Stack } from '@mui/material';
import { PalletProvider, usePallet } from '../../../../contexts/PalletContext';
// import ButtonIconLeft from '../../../components/ButtonIconLeft';
import useStyles from '../../../../components/layout/Styles';
// import PlaceIcon from '@material-ui/icons/Place';
import ProposicaoAcontecimentosService from '../../../../services/ProposicaoAcontecimentosService';
import { formatDate } from '../../../../utils/dateUtils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InputDatePicker from '../../../../components/InputDatePicker';
import InputMultilineTextField from '../../../../components/InputMultilineTextField'
// import ButtonIconSalvar from '../../../components/ButtonIconSalvar';
import SolidButton from '../../../../components/SolidButton';
import CloseIcon from '@mui/icons-material/Close';
import AnexosComponent, { EAnexoModulos } from '../../../../components/Anexos';
// import AnexosItemComponent from '../../../components/Anexos';
import { useAlert } from '../../../../contexts/AlertContext';
import UploadFilesService from '../../../../services/UploadFiles.service';
import MenuButtonIconNoText from "../../../../components/MenuButtonIconNoText";
import { MoreHoriz } from "@material-ui/icons";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
// import CustomizedDialogs from './DialogEdit';
import MenuItem from '@mui/material/MenuItem';
import Menu, { MenuProps } from '@mui/material/Menu';
import EmptyErrorDoc from '../../../../components/EmptyErrorDoc';
import ButtonDialogConfirmation from '../../../../components/ButtonDialogConfirmation';
import CircularLoading from '../../../../components/CircularLoading';
import FilterQuantity from '../../../../components/filter/FilterQuantity';
import AcontecimentosProposicaoEdicao from './TramitacaoProposicaoEdicao';
import ProposicaoAcontecimentosCreateSchema from '../../models/ProposicaoAcontecimentosCreateSchema'
import ProposicaoService from '../../../../services/ProposicaoService';
import ProposicaoTramitacaoCreateSchema from '../../models/ProposicaoTramitacaoCreateSchema';
import SelectTextFieldA from '../../../../components/SelectTextFieldA';
import EmptyErrorDocCarousel from '../../../../components/EmptyErrorDocCarousel';
import TramitacaoProposicaoEdicao from './TramitacaoProposicaoEdicao';
import PaginationSaveState from '../../../../components/PaginationSaveState';
import TabelasService from '../../../../services/TabelasService';
import { useAuthorization } from '../../../../contexts/AuthorizationContext';
import * as helpers from '../../../../helpers/helpers';
import moment from 'moment';
import ComJabuti from "../../../../img/michaelangelo_jabuti_vermelho.png";
import SemJabuti from "../../../../img/michaelangelo_sem_jabuti.png";
import {
    ProgressoJabuti,
    LIMITE_ACOMPANHAMENTO_MS,
    INTERVALO_POLLING_MS,
} from "../../../../components/ProgressoJabuti";
import LinkIcon from "@mui/icons-material/Link";
import { identity } from 'lodash';
import clsx from 'clsx';


const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(0),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '0px 0'
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));


export interface IFileInfo {
    name: string,
    filename: string,
    size: number,
    new: boolean,
    file: any
}

export default function ProposicaoTramitacoes(props: {
    id_proposicao: number,
    index: number,
    activeTab: number,
    proposicao_integrada?: boolean,
    onChange?: any,
    propCasa?: number,
    statusProcessamentoIa?: boolean;
}) {

    const { NewAlert } = useAlert();
    const classes = useStyles();
    const { pallet } = usePallet();
    const [loading, setLoading] = useState(false)
    const [tramitacoes, setTramitacoes] = useState<Array<any>>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [currentPageSize, setCurrentPageSize] = useState<number>(50);
    const [infoList, setInfoList] = useState<any>();
    const [dataTramitacao, setDataTramitacao] = useState();
    const [situacaoTramitacao, setSituacaoTramitacao] = useState<any>(null);
    const [tramitacoesSituacoes, setTramitacoesSituacoes] = useState([{ key: 0, label: '', value: 0 }]);
    const [descricao, setDescricao] = useState("");
    const [idReferencia, setIdReferencia] = React.useState<any>();
    const [camposPreenchidos, setCamposPreenchidos] = useState(false);
    // const [limparAnexosSalvos, setLimparAnexosSalvos] = React.useState(false)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [open, setOpen] = React.useState();
    const [openIA, setOpenIA] = useState(false);
    const [dialogOpen, setDialogOpen] = React.useState(false)
    const handleOnChangeItensPerPageSize = (data: any) => {
        setCurrentPageSize(Number(data.target.value));
        setCurrentPage(1)
    };
    const [error, setError] = useState<Array<{ name: string, err: string }>>([]);
    const [data, setData] = useState({});
    const [loadingForm, setLoadingForm] = useState(false)
    const [totalLista, setTotalLista] = useState<number>()
    const [loadingAfterSalvar, setLoadingAfterSalvar] = useState(false);

    const [expandedAcordion, setExpandedAcordion] = useState(false);
    const { user } = useAuthorization();
    const { getConfig } = useAuthorization();
    const [dots, setDots] = useState('');
    const [dialogIndex, setDialogIndex] = useState<number | null>(null);
    // Estado POR tramitação. Antes era um único { status, id }: disparar uma segunda
    // análise apagava o indicador da primeira — que continuava rodando, só que
    // invisível. Cada linha da lista agora carrega o seu próprio acompanhamento.
    // Formato: { [id_tramitacao]: { iniciadoEm, progresso, expirou } }
    const [analisesJabuti, setAnalisesJabuti] = React.useState<Record<number, any>>({});
    const pollsRef = React.useRef<Record<number, any>>({});
    const [agora, setAgora] = React.useState(Date.now());
    const [hitSaveUpload, setHitSaveUpload] = useState(false);

    // PROCESSAR x EXIBIR — ver a mesma separação em ProposicaoConsultaInformacoes.
    // O par (habIa && habJabuti) libera o botão e o indicador de etapa; habJabutiFront,
    // independente de habIa, libera o ícone e o parecer do que já foi analisado.
    const podeProcessarJabuti = !!(getConfig()?.habIa && getConfig()?.habJabuti);
    const podeExibirJabuti = !!getConfig()?.habJabutiFront;




    const PaperContent = styled(Paper)`
	color: ${pallet.textColorQuaternary};
	font-size: ${pallet.fontSize.titleWidgets};
	font-family: ${pallet.fontFamily.general};
	font-weight: 600;
	padding-top: 5%;
	padding-bottom: 10%;
	width: 100%;
	text-align: center;
	background-color: #ffff;    
`;

    const ErrorMessage = (props: { name: string, errors: Array<{ name: string, err: string }> }) => {
        const itemError = props.errors.filter(err => err.name === props.name);
        return (
            <div style={{ color: 'red' }}>
                {itemError.length === 1 && itemError[0].err}
            </div>
        )
    }







    React.useEffect(() => {
        if (props.activeTab === props.index)
            loadTramitacoes(props.id_proposicao)
    }, [props.activeTab, currentPage, currentPageSize]);


    const handleClick = (event: React.MouseEvent<HTMLElement>, id) => {
        setOpen(id)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpen(undefined)
    };


    const handleDataTramitacaoChange = (dateAc) => {
        setDataTramitacao(dateAc)
    };

    const handleDescricaoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(event.target.value)
    };

    const handleSituacaoTramitacaoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSituacaoTramitacao(event.target.value);
    };

    const loadingListAfterSalvar = () => {
        setLoadingAfterSalvar(true)


        setTimeout(() => {
            loadTramitacoes(props.id_proposicao);
            setLoadingAfterSalvar(false)
        }, 2000);
        props.onChange()
    }

    const handleChangeAcordion =
        (ativo: boolean) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpandedAcordion(!ativo);
        };

    async function loadTramitacoes(id_proposicao: number) {
        // setLoading(true) - Retirado loading na implementacao da IA Jabuti em cada item da lista de tramitacoes. (Temporario)
       setLoading(true)
        await ProposicaoService.GetTramitacao(id_proposicao, currentPage, currentPageSize)
            .then(tramitacoes => {

                setTotalLista(tramitacoes?.listInfo?.totalItens)

                if (tramitacoes && tramitacoes.listInfo) {
                    setInfoList(() => { return { ...tramitacoes.listInfo } })
                    setLoading(false)
                };
                if (tramitacoes && tramitacoes.lista) {
                    setTramitacoes(() => { return [...tramitacoes.lista] })
                    setLoading(false)
                    retomarAnalisesEmAndamento(tramitacoes.lista)
                };

                loadTramitacoesSituacoes();
                
                props.onChange();

            })
    }

    async function loadTramitacoesSituacoes() {

        TabelasService.getTabelaTramitacaoSituacoes()
            .then(res => {
                const dataresp = res?.map(item => {
                    return {
                        key: item.codsituacao,
                        label: item.descsituacao,
                        value: item.codsituacao
                    }
                });
                dataresp && setTramitacoesSituacoes(dataresp);
            })

    }

    React.useEffect(() => {
        if (!idReferencia && props.id_proposicao) {
            setDataTramitacao(undefined)
            setSituacaoTramitacao(undefined);
            setDescricao("")

            loadTramitacoes(props.id_proposicao);
        }
    }, [idReferencia])

    async function handleOnAfterUpload() {
        if (idReferencia) {
            setHitSaveUpload(false)
            setIdReferencia(undefined);
            NewAlert('success', 'Tramitação cadastrada com sucesso')
            setLoadingForm(false)
            setLoading(false)
            loadingListAfterSalvar();
        }
    }

    const setPage = (event: object, page: number) => setCurrentPage(page);

    const postTramitacao = async (e) => {
        setLoading(true)
        setLoadingForm(true)
        e.preventDefault();
        const data = {
            date: dataTramitacao ? dataTramitacao : new Date(),
            situacao: situacaoTramitacao,
            descricao: descricao,
        }

        setError(() => [])
        data && ProposicaoTramitacaoCreateSchema
            .validate(data, { abortEarly: false })
            .catch(err => setError(() => err.errors));

        setData(data)

        ProposicaoTramitacaoCreateSchema.validate(data).catch(function (err) {
        });

        if (ProposicaoTramitacaoCreateSchema.isValidSync(data)) {
            await ProposicaoService.CreateTramitacao(data, props?.id_proposicao)
                .then(res => {
                    let idTramitacao = res
                    if (res && res > 0) {
                        setIdReferencia(idTramitacao)
                        setHitSaveUpload(true)

                    } else {
                        setLoadingForm(false)
                        setLoading(false)
                        NewAlert('error', 'Erro ao cadastrar, verifique os campos e salve novamente');
                    }
                })//.then(x => loadAcontecimentos(props.id_proposicao))
        } else {
            NewAlert('error', 'Algum campo está incorreto ou vazio, verifique!');
            setTimeout(() => {
                setLoadingForm(false)
                setLoading(false)
            }, 100);
        }
    }

    const deletarEdicaoTramitacoes = (id) => {
        ProposicaoService.DeleteTramitacao(id).then(res => {
            if (res) {
                handleClose()
                NewAlert('success', 'Tramitação apagada com sucesso')
                setExpandedAcordion(false)
                loadTramitacoes(props?.id_proposicao)
                props.onChange()
            } else {
                NewAlert('error', 'Erro ao apagar, verifique os campos e apague novamente');
            }
        })

    }


    const erroAlteracaoPerfil = () => {
        NewAlert(
            "error",
            "Não é possível realizar está ação com este perfil."
        );
    }

    const tipoTramitacao = (texto) => {
        // retorna uma desses tipos: "Emenda", "Parecer", "Requerimento", "Relatório Legislativo"
        try {
            const data = JSON.parse(texto);

            // Garante que é um array
            if (!Array.isArray(data)) return false;

            return data[0].assunto;
        } catch (e) {
            return false;
        }
    };

    const verificarAssunto = (texto) => {
        // "Emenda", "Parecer", "Requerimento", "Relatório Legislativo" -  retorna true
        try {
            const data = JSON.parse(texto);

            // Garante que é um array
            if (!Array.isArray(data)) return false;

            const assuntosValidos = ["Emenda", "Parecer", "Requerimento", "Relatório Legislativo"];

            return data.some(item => assuntosValidos.includes(item.assunto));
        } catch (e) {
            return false;
        }
    };

    const pararAcompanhamento = (id: number) => {
        if (pollsRef.current[id]) {
            clearInterval(pollsRef.current[id]);
            delete pollsRef.current[id];
        }
    };

    const esquecerAnalise = (id: number) => {
        setAnalisesJabuti(prev => {
            if (!prev[id]) return prev;
            const novo = { ...prev };
            delete novo[id];
            return novo;
        });
    };

    const consultarStatusJabuti = async (id: number, inicio: number) => {
        try {
            const res = await ProposicaoService.GetStatusProcessamentoIATramitacao(Number(id));

            if (!res?.data?.processamento_ia) {
                pararAcompanhamento(id);
                esquecerAnalise(id);
                loadTramitacoes(props.id_proposicao);   // recarrega já com o jabuti gravado
                return;
            }

            const progresso = res?.data?.progresso ?? null;
            setAnalisesJabuti(prev => {
                if (!prev[id]) return prev;
                // O back sabe quando a análise REALMENTE começou; o front só sabe
                // quando começou a olhar. Depois de um F5 os dois divergem, e quem
                // vale para o cronômetro é o do back.
                const iniciadoEm = progresso?.iniciado_em
                    ? new Date(progresso.iniciado_em).getTime()
                    : prev[id].iniciadoEm;
                return { ...prev, [id]: { ...prev[id], progresso, iniciadoEm } };
            });

            // Teto de acompanhamento. Sem ele o indicador gira para sempre quando
            // ninguém consome a fila — exatamente o que o cliente reclamou de ver.
            // Não cancela nada no back: só para de prometer que a tela vai atualizar.
            if (Date.now() - inicio > LIMITE_ACOMPANHAMENTO_MS) {
                pararAcompanhamento(id);
                setAnalisesJabuti(prev => (
                    prev[id] ? { ...prev, [id]: { ...prev[id], expirou: true } } : prev
                ));
            }
        } catch (err) {
            console.error('[jabuti] falha ao consultar status da tramitação:', err);
        }
    };

    const iniciarAcompanhamento = (id: number, inicio: number) => {
        pararAcompanhamento(id);
        setAnalisesJabuti(prev => ({ ...prev, [id]: { iniciadoEm: inicio, progresso: null, expirou: false } }));
        pollsRef.current[id] = setInterval(() => consultarStatusJabuti(id, inicio), INTERVALO_POLLING_MS);
    };

    // Retoma o indicador depois de um F5 (ou de trocar de página da lista): sem isto
    // a tela voltava a oferecer o botão no meio de uma análise em curso. O
    // `processamento_ia` já vem em cada tramitação da própria listagem, então isso não
    // custa uma requisição por linha. O cronômetro parte de agora e é corrigido pelo
    // `iniciado_em` do back no primeiro polling.
    const retomarAnalisesEmAndamento = (lista: Array<any>) => {
        if (!Array.isArray(lista)) return;
        lista.forEach(item => {
            if (item?.processamento_ia && !pollsRef.current[item.id]) {
                iniciarAcompanhamento(item.id, Date.now());
            }
        });
    };

    const handleClickProcessIA = async (id_tramitacao) => {
        if (!id_tramitacao || analisesJabuti[id_tramitacao]) return;

        const inicio = Date.now();
        iniciarAcompanhamento(id_tramitacao, inicio);

        try {
            const respIA = await ProposicaoService.sendMqProcessaIaJabutiSenadoCongresso({
                id_tramitacao: id_tramitacao,
                id_proposicao_originaria: props.id_proposicao
            });
            // Duas formas de "não foi": o back recusou por regra (já analisado, já em
            // andamento, IA desligada) e devolveu enfileirado:false; ou a chamada
            // falhou e o service devolveu o sentinela 0. Nos dois casos não há
            // processamento — tira o indicador na hora, em vez de deixar o usuário
            // esperando 5 minutos por algo que nunca foi enfileirado.
            if (!respIA || respIA.enfileirado === false) {
                console.warn(`[jabuti] tramitação ${id_tramitacao} não enfileirada:`, respIA?.motivo ?? 'falha na chamada à API');
                pararAcompanhamento(id_tramitacao);
                esquecerAnalise(id_tramitacao);
            }
        } catch (err) {
            console.error('[jabuti] falha ao solicitar análise da tramitação:', err);
            pararAcompanhamento(id_tramitacao);
            esquecerAnalise(id_tramitacao);
        }
    }

    // Limpa TODOS os intervalos ao desmontar. O código anterior devolvia um
    // `() => clearInterval(...)` de dentro de uma função comum — ninguém consumia
    // esse retorno, então cada disparo deixava um interval vivo batendo na API
    // depois que o usuário já tinha saído da página.
    React.useEffect(() => () => {
        Object.values(pollsRef.current).forEach((t: any) => clearInterval(t));
        pollsRef.current = {};
    }, []);

    // Cronômetro do indicador: um tick por segundo, e só enquanto há análise viva.
    const haAnaliseViva = Object.values(analisesJabuti).some((a: any) => a && !a.expirou);
    React.useEffect(() => {
        if (!haAnaliseViva) return;
        const t = setInterval(() => setAgora(Date.now()), 1000);
        return () => clearInterval(t);
    }, [haAnaliseViva]);

    return (
        <div
        // style={{ minHeight: "800px" }}
        >
            {/* ---------------------------- CONTEÚDO DE TRAMITAÇÕES ------------------------------ */}
            {/* <CustomizedDialogs /> */}
            <div style={{ fontFamily: `${pallet.fontFamily.general}` }}>

               
                   
                    <Grid className={clsx({ [classes.hidden]: !loadingForm })}>

                        <CircularLoading
                            size={80}
                            top={"90%"}
                            left={"50%"}
                            zIndex={2}
                        />
                    </Grid>

                         {

                        !props.proposicao_integrada ?
                            <Grid className={clsx({ [classes.hidden]: loadingForm })}>

                                < Grid >
                                    <Grid style={{ paddingLeft: `${isMobile ? "0px" : "30px"}`, paddingRight: `${isMobile ? "0px" : "30px"}`, paddingBottom: `${isMobile ? "20px" : "45px"}` }}>
                                        <Accordion elevation={0} style={{ border: "1px solid #EAEAEA" }} onChange={handleChangeAcordion(expandedAcordion)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon style={{ color: `${pallet.color.primary.font}` }} />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                style={{
                                                    backgroundColor: `${pallet.color.primary.background}`,
                                                    borderRadius: "5px",
                                                    paddingLeft: "20px",
                                                    paddingRight: "20px",
                                                    flexFlow: "row-reverse",
                                                    height: "64px"
                                                }}
                                            >
                                                <Typography className={classes.heading} style={{
                                                    color: `${pallet.color.primary.font}`,
                                                    fontFamily: `${pallet.fontFamily.general}`,
                                                    fontSize: `${pallet.fontSize.titleWidgets}`,
                                                    fontWeight: pallet.fontWeight.subtitle,
                                                    marginLeft: "10px"
                                                }}>
                                                    NOVO REGISTRO
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{
                                                fontFamily: `${pallet.fontFamily.general}`
                                            }}>
                                                <Grid container spacing={2} style={{ padding: "25px 20px 20px 20px" }}>
                                                    <Grid item lg={6} xs={12}>
                                                        <InputDatePicker
                                                            onChange={handleDataTramitacaoChange}
                                                            label={"DATA DE REGISTRO"}
                                                            inputFormat={"dd/MM/yyyy"}
                                                            value={dataTramitacao}
                                                            defaultValue={dataTramitacao}
                                                            id={"dataRegistro-tramitacao"}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} xs={12}>
                                                        <SelectTextFieldA
                                                            value={situacaoTramitacao}
                                                            //onChange={handleSituacaoTramitacaoChange}
                                                            onChange={(e) => handleSituacaoTramitacaoChange(e)}
                                                            options={tramitacoesSituacoes}
                                                            label={"SITUAÇÃO"}
                                                            id={"situacao-tramitacao"}
                                                        />
                                                        <Grid style={{ color: 'red', fontSize: '10px', marginTop: "2px", marginLeft: "2px" }}>
                                                            <ErrorMessage name='situacao' errors={error} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item style={{ marginTop: "5px" }} lg={12} xs={12}>
                                                        <InputMultilineTextField
                                                            type={"text"}
                                                            maxRows={4}
                                                            value={descricao}
                                                            defaultValue={descricao}
                                                            onChange={handleDescricaoChange}
                                                            id={"descricao-tramitacao"}
                                                            label="DESCRIÇÃO"
                                                        />
                                                        <Grid style={{ color: 'red', fontSize: '10px', marginTop: "2px", marginLeft: "2px" }}>
                                                            <ErrorMessage name='descricao' errors={error} />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </AccordionDetails>

                                            <Grid style={{ paddingBottom: "10px" }}>
                                                <Divider />
                                            </Grid>

                                            <Grid style={{ padding: "20px 18px 20px 18px" }}>
                                                <Grid xs={12} lg={12} style={{ marginBottom: `${isMobile ? "8px" : "0px"}` }}>
                                                    <Grid style={{
                                                        fontWeight: pallet.fontWeight.subtitle,
                                                        fontSize: `${pallet.general.size12}`,
                                                        color: `${pallet.color.tertiary.font}`,
                                                        marginLeft: "9px"
                                                    }}>
                                                        ANEXOS
                                                    </Grid>

                                                    <Grid className="container">
                                                        <AnexosComponent
                                                            label=''
                                                            modulo={EAnexoModulos.Tramitacao}
                                                            id_referencia={idReferencia}
                                                            canEdit={true}
                                                            autosave={false}
                                                            save={hitSaveUpload}
                                                            onAfterUpload={handleOnAfterUpload}
                                                        // limparAnexo={limparAnexosSalvos}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid>
                                                <Divider />
                                            </Grid>
                                            <Grid container justifyContent="flex-end"
                                                style={{
                                                    backgroundColor: `${pallet.backgroundColorTertiary}`,
                                                    padding: "35px 30px 35px 30px"
                                                }}>

                                                <Grid>
                                                    <SolidButton
                                                        onClick={user.id_permissao !== 3 ? postTramitacao : erroAlteracaoPerfil}
                                                        // disabled={lockSaveButton}
                                                        color={`${pallet.textColorPrimary}`}
                                                        backgroundColor={`${pallet.backgroundColorPrimary}`}
                                                        fontSize={`${pallet.general.size14}`}
                                                        title={"SALVAR"}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Accordion>
                                    </Grid>
                                </Grid>
                                {
                                    //infoList?.totalItens === undefined || (infoList?.totalItens <= 0 && !infoList?.totalNoFilter) &&
                                    tramitacoes?.length ? (
                                        < Divider />

                                    ) : !expandedAcordion && (
                                        <Grid
                                            style={{
                                                color: `${pallet.textColorQuaternary}`,
                                                fontSize: `${pallet.fontSize.titleWidgets}`,
                                                fontFamily: `${pallet.fontFamily.general}`,
                                                fontWeight: 600,
                                                textAlign: "center",
                                                paddingBottom: "50px",
                                                marginTop: "20px",
                                            }}
                                        >
                                            <EmptyErrorDoc title="Comece criando uma nova Tramitação"
                                                description="Você ainda não criou nenhuma Tramitação para esta proposição."
                                                subdescription="" />
                                        </Grid>

                                    )}
                            </Grid>
                            :

                            //infoList?.totalItens === undefined || (infoList?.totalItens <= 0 && !infoList?.totalNoFilter) &&
                            !tramitacoes?.length &&
                            <Grid>
                                <PaperContent>
                                    <EmptyErrorDocCarousel title="Esta proposição não possui Tramitações" description="" />
                                </PaperContent>
                            </Grid>
                }
                <Grid style={{ padding: `${isMobile ? "5px 5px 0px 15px" : "0px 35px 20px 40px"}` }}>
                    {
                        totalLista <= 4 ?
                            null
                            :
                            <Grid style={{ marginTop: "20px", marginBottom: "20px" }}>
                                <FilterQuantity
                                    list={infoList}
                                    currentPageSize={currentPageSize}
                                    onChange={handleOnChangeItensPerPageSize}
                                />
                            </Grid>
                    }
                    {
                        loading ?
                            <CircularLoading
                                size={80}
                                top={"50%"}
                                left={"50%"}
                                zIndex={2}
                            />
                            :
                            loadingAfterSalvar === true ?
                                <CircularLoading
                                    size={80}
                                    top={"50%"}
                                    left={"50%"}
                                    zIndex={2}
                                />
                                :
                                <Box style={{ marginTop: "15px" }}>
                                    <Stepper orientation="vertical">
                                        {tramitacoes?.map((item, index) => {
                                            const hasJabutiItem = Array.isArray(item.jabutis) && item.jabutis.length > 0;
                                            const isIdentified = hasJabutiItem && Boolean(item.jabutis[0].isJabuti);
                                            // Senado E Congresso Nacional: o processador do
                                            // legisnote-update trata as duas casas pelo mesmo
                                            // fluxo (chaveado por id_tramitacao), e há tramitações
                                            // elegíveis de Congresso na base que antes nunca
                                            // apareciam por causa do teste só de 'Senado Federal'.
                                            // O botão some quando já existe análise — aí entra o
                                            // ícone com o dialog.
                                            const casaTramitacao = item?.casa?.trim();
                                            const ehSenadoOuCongresso = casaTramitacao === 'Senado Federal' || casaTramitacao === 'Congresso Nacional';
                                            // Análise em curso NESTA linha. Enquanto existir, o botão
                                            // dá lugar ao indicador de etapa — o usuário não pode
                                            // continuar clicando e enfileirando a mesma análise.
                                            const analiseEmCurso = analisesJabuti[item.id];
                                            const mostrarBotaoIA = ehSenadoOuCongresso
                                                && verificarAssunto(item.url)
                                                && !hasJabutiItem
                                                && !analiseEmCurso
                                                && podeProcessarJabuti;
                                            return (
                                                <Step expanded active={false}>
                                                    <StepLabel
                                                        icon={
                                                            <Grid container >
                                                                <Grid
                                                                    style={{
                                                                        marginTop: "-8px",
                                                                        marginLeft: "-7px",
                                                                        borderRadius: "50%",
                                                                        width: "42px",
                                                                        height: "42px",
                                                                        position: "relative",
                                                                        boxShadow: "1px 0.5px 4px 0 rgb(0 0 0 / 10%), 0 3px 10px 0 rgb(0 0 0 / 9%)",
                                                                        backgroundColor: (index === 0 && currentPage === 1) ? `${pallet.backgroundColorQuintenary}` : `${pallet.backgroundColorQuaternary}`
                                                                    }}
                                                                >
                                                                    <Grid style={{
                                                                        position: "absolute",
                                                                        borderRadius: "50%",
                                                                        top: "50%",
                                                                        left: "50%",
                                                                        width: "15px",
                                                                        height: "15px",
                                                                        margin: "-7.5px 0px 0px -7.5px",
                                                                        zIndex: 1,
                                                                        backgroundColor: "white",
                                                                        border: (index === 0 && currentPage === 1) ? `3px solid ${pallet.backgroundColorPrimary}` : `3px solid ${pallet.general.color4}`
                                                                    }} >
                                                                        {(index === 0 && currentPage === 1) ?
                                                                            <Grid style={{
                                                                                position: "absolute",
                                                                                top: "50%",
                                                                                left: "50%",
                                                                                borderRadius: "50%",
                                                                                width: "7px",
                                                                                height: "7px",
                                                                                margin: "-3.5px 0px 0px -3.5px",
                                                                                zIndex: 1,
                                                                                backgroundColor: `${pallet.backgroundColorPrimary}`
                                                                            }}>

                                                                            </Grid>
                                                                            : null}

                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                        optional={
                                                            <Grid container justifyContent={"space-between"}>
                                                                <Grid>
                                                                    <Grid container style={{ fontSize: "12px", fontFamily: `${pallet.general.fontFamily}` }}>
                                                                        <Grid item style={{ marginRight: "5px" }}>
                                                                            {moment(item.data_evento).format("DD/MM/YYYY")}
                                                                        </Grid>
                                                                        {/* <Grid item style={{ marginTop: "-12px", marginRight: "5px", fontSize: "25px" }}>
                                                            •
                                                        </Grid>
                                                        <Grid item style={{}}>
                                                            {formatDate(new Date(item.data_evento), "HH:mm")}
                                                        </Grid> */}
                                                                    </Grid>
                                                                </Grid>

                                                                {/* Editar e apagar ...  */}
                                                                {!props.proposicao_integrada &&
                                                                    <Grid style={{ marginTop: "-25px", paddingRight: "10px", marginBottom: "-30px" }}>
                                                                        <Button
                                                                            id={`button-${item.id}`}
                                                                            aria-controls={anchorEl ? `mmenu-${item.id}` : undefined}
                                                                            disableElevation
                                                                            variant="contained"
                                                                            size="large"
                                                                            style={{
                                                                                backgroundColor: `${pallet.general.color3}`,
                                                                                textTransform: 'capitalize',
                                                                                fontFamily: `${pallet.fontFamily.general}`,
                                                                                fontWeight: pallet.fontWeight.button,
                                                                                fontSize: `${pallet.fontSize.smallButton}`,
                                                                                color: `${pallet.color.secundary.font}`,
                                                                                width: "25px",
                                                                                height: "40px",
                                                                            }}
                                                                            onClick={(e) => handleClick(e, item.id)}
                                                                            endIcon={<Grid style={{ fontSize: "30px", color: pallet.general.color4, marginTop: "9px", marginRight: "10px" }}>
                                                                                <MoreHoriz fontSize='inherit' />
                                                                            </Grid>
                                                                            }
                                                                        >
                                                                        </Button>
                                                                        <StyledMenu
                                                                            id={`mmenu-${item.id}`}
                                                                            MenuListProps={{
                                                                                'aria-labelledby': `button-${item.id}`,
                                                                            }}
                                                                            anchorEl={anchorEl}
                                                                            open={open === item.id}
                                                                            onClose={handleClose}
                                                                        >
                                                                            <MenuItem >
                                                                                <TramitacaoProposicaoEdicao
                                                                                    idTramitacao={item.id}
                                                                                    reloadList={() => loadTramitacoes(props?.id_proposicao)}
                                                                                    closeMenu={() => handleClose()}
                                                                                    onChange={() => props?.onChange()}
                                                                                    idProposicao={props?.id_proposicao}
                                                                                />
                                                                            </MenuItem>
                                                                            <Divider style={{ marginTop: "0px", marginBottom: "0px" }} />
                                                                            <MenuItem
                                                                                style={{
                                                                                    fontFamily: `${pallet.fontFamily.general}`,
                                                                                    fontWeight: pallet.fontWeight.button,
                                                                                    fontSize: `${pallet.general.size14}`,
                                                                                    color: `${pallet.color.tertiary.font}`,
                                                                                    borderRadius: "6px",
                                                                                    padding: "6px",

                                                                                }}>
                                                                                <ButtonDialogConfirmation
                                                                                    styles={{
                                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                                        fontWeight: pallet.fontWeight.button,
                                                                                        fontSize: `${pallet.general.size14}`,
                                                                                        color: `${pallet.color.tertiary.font}`,
                                                                                        borderRadius: "6px",
                                                                                        textTransform: "capitalize"
                                                                                    }}
                                                                                    title={"CONFIRMAÇÃO"}
                                                                                    // lastPath={"/parlamentar"}                                                                    
                                                                                    confirmationEvent={() => user.id_permissao !== 3 ? deletarEdicaoTramitacoes(item.id) : NewAlert(
                                                                                        "error",
                                                                                        "Não é possível realizar está ação com este perfil."
                                                                                    )}
                                                                                    title_button={"Apagar"}
                                                                                    confirmation_button={"Apagar"}
                                                                                    content={"APAGAR REGISTRO?"}
                                                                                    message={"Esta ação não poderá ser desfeita."}
                                                                                >
                                                                                    <DeleteIcon style={{
                                                                                        color: `${pallet.color.tertiary.font}`,
                                                                                        marginRight: "16px",
                                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                                    }} />

                                                                                </ButtonDialogConfirmation>
                                                                            </MenuItem>
                                                                        </StyledMenu>
                                                                    </Grid>
                                                                }
                                                            </Grid>
                                                        }
                                                    >
                                                        {item.casa}
                                                    </StepLabel>
                                                    <StepContent>
                                                        <Grid style={{ padding: "15px", border: "1px solid #EAEAEA", borderRadius: "6px", backgroundColor: (index === 0 && currentPage === 1) ? `${pallet.backgroundColorQuintenary}` : null }}>
                                                            <Grid>
                                                                <Grid container justifyContent={'space-between'}>
                                                                    <Grid item>
                                                                        <Typography style={{
                                                                            fontFamily: `${pallet.general.fontFamily}`,
                                                                            fontSize: "13px",
                                                                            fontWeight: pallet.fontWeight.subtitle,
                                                                        }}>
                                                                            {item.desc_situacao} {tipoTramitacao(item.url) ? `- (${tipoTramitacao(item.url)})` : null}
                                                                        </Typography>
                                                                    </Grid>
                                                                    {/* Duas metades com gates próprios: indicador de progresso e
                                                                        botão de disparo dependem de PROCESSAR; ícone e dialog do
                                                                        parecer dependem de EXIBIR. Assim, desligar HAB_JABUTI para
                                                                        conter custo não apaga da tela o que já foi analisado. */}
                                                                    {podeProcessarJabuti || podeExibirJabuti
                                                                        ?
                                                                        <>
                                                                            {podeProcessarJabuti && analiseEmCurso
                                                                                ?
                                                                                <Grid
                                                                                    style={{
                                                                                        borderRadius: '0px 8px 8px 8px',
                                                                                        padding: '20px',
                                                                                        margin: '0px 10px 10px 0px'
                                                                                    }}
                                                                                >
                                                                                    {/* Etapa + cronômetro no lugar do texto estático: sem eles
                                                                                        não há como distinguir "rodando" de "travado". */}
                                                                                    <ProgressoJabuti
                                                                                        etapa={analiseEmCurso.progresso?.etapa}
                                                                                        totalEtapas={analiseEmCurso.progresso?.total_etapas}
                                                                                        rotulo={analiseEmCurso.progresso?.etapa_rotulo}
                                                                                        decorridoMs={agora - (analiseEmCurso.iniciadoEm || agora)}
                                                                                        expirou={analiseEmCurso.expirou}
                                                                                    />
                                                                                </Grid>
                                                                                :
                                                                                <>
                                                                                    <Grid item>
                                                                                        {!podeExibirJabuti || !hasJabutiItem
                                                                                            ?
                                                                                            null
                                                                                            :
                                                                                            <Grid item onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                setDialogIndex(index);
                                                                                            }} style={{ cursor: 'pointer' }}>
                                                                                                <img
                                                                                                    src={isIdentified ? ComJabuti : SemJabuti}
                                                                                                    alt="icone"
                                                                                                    style={{ width: '40px', height: '40px', marginLeft: 'auto' }}
                                                                                                />
                                                                                            </Grid>
                                                                                        }
                                                                                        <Dialog open={dialogIndex === index && podeExibirJabuti}
                                                                                            onClose={() => setDialogIndex(null)}
                                                                                            fullWidth maxWidth="md">
                                                                                            <Grid onClick={(e) => e.stopPropagation()}>
                                                                                                <DialogTitle>
                                                                                                    {isIdentified ? "JABUTI IDENTIFICADO!" : "JABUTI NÃO IDENTIFICADO."}
                                                                                                    <IconButton
                                                                                                        aria-label="fechar"
                                                                                                        onClick={() => setDialogIndex(null)}
                                                                                                        style={{ position: 'absolute', right: 8, top: 8 }}
                                                                                                    >
                                                                                                        <CloseIcon />
                                                                                                    </IconButton>
                                                                                                </DialogTitle>
                                                                                                <DialogContent dividers style={{ whiteSpace: "pre-wrap" }}>
                                                                                                    {/* `parecer` é o texto da Etapa 4 do pipeline, o mesmo
                                                                                                        conteúdo que vai na notificação de jabuti. O HTML já
                                                                                                        vem escapado da origem. Linhas antigas não têm parecer
                                                                                                        e caem no `descricao` de sempre. */}
                                                                                                    {item?.jabutis[0]?.parecer
                                                                                                        ?
                                                                                                        <div
                                                                                                            style={{ whiteSpace: 'normal' }}
                                                                                                            dangerouslySetInnerHTML={{ __html: item.jabutis[0].parecer }}
                                                                                                        />
                                                                                                        :
                                                                                                        item?.jabutis[0]?.descricao}
                                                                                                    <Grid
                                                                                                        container
                                                                                                        style={{
                                                                                                            fontSize: pallet.general.size14,
                                                                                                            marginTop: '2px',
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                        }}
                                                                                                    >
                                                                                                        <Grid item>
                                                                                                            <LinkIcon />
                                                                                                        </Grid>
                                                                                                        <Grid item style={{ marginLeft: 16 }}>
                                                                                                            {item.jabutis.length > 0 && item.jabutis[0].id_proposicao_principal ? (
                                                                                                                <a
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                    style={{
                                                                                                                        textDecoration: 'none',
                                                                                                                        fontWeight: pallet.general.weight_600,
                                                                                                                    }}
                                                                                                                    href={`/proposicao/${item.jabutis[0].id_proposicao_principal}`}
                                                                                                                >
                                                                                                                    PROPOSIÇÃO PRINCIPAL
                                                                                                                </a>
                                                                                                            ) : (
                                                                                                                "PROPOSTA NÃO INFORMADA"
                                                                                                            )}
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                    <Typography variant="caption" style={{ display: 'block', marginTop: '8px', fontSize: '0.6rem' }}>
                                                                                                        {item.jabutis.length > 0 && item.jabutis[0].jabuti_criado_em ? (
                                                                                                            <>Data de processamento: {moment(item.jabutis[0].jabuti_criado_em).format("DD/MM/yyyy HH:mm")}</>
                                                                                                        ) : (
                                                                                                            <>Não processado.</>
                                                                                                        )}
                                                                                                    </Typography>
                                                                                                </DialogContent>
                                                                                            </Grid>
                                                                                        </Dialog>
                                                                                    </Grid>
                                                                                </>
                                                                            }
                                                                        </>
                                                                        :
                                                                        null
                                                                    }
                                                                    {mostrarBotaoIA
                                                                        ?
                                                                        <Grid item>
                                                                            <Button
                                                                                id={`button-${item.id}`}
                                                                                aria-controls={anchorEl ? `mmenu-${item.id}` : undefined}
                                                                                // disableElevation
                                                                                variant="contained"
                                                                                size="small"
                                                                                style={{
                                                                                    backgroundColor: `${pallet.general.color1}`,
                                                                                    textTransform: 'none',
                                                                                    fontFamily: `${pallet.fontFamily.general}`,
                                                                                    fontWeight: pallet.fontWeight.button,
                                                                                    fontSize: `${pallet.fontSize.smallButton}`,
                                                                                    color: 'white',
                                                                                    whiteSpace: 'nowrap',
                                                                                }}
                                                                                onClick={() => handleClickProcessIA(item.id)}
                                                                            >
                                                                                Analisar Jabuti
                                                                            </Button>
                                                                        </Grid>
                                                                        :
                                                                        null}
                                                                </Grid>
                                                                {props.propCasa <= 3 ?
                                                                    <Typography
                                                                        style={{
                                                                            wordBreak: "break-word",
                                                                            padding: "10px",
                                                                            // boxShadow: "1px 0.5px 4px 0 rgb(0 0 0 / 10%), 0 3px 10px 0 rgb(0 0 0 / 9%)",
                                                                            fontFamily: `${pallet.general.fontFamily}`,
                                                                            fontSize: "13px"
                                                                        }}>
                                                                        <b>{item.sigla}</b> {item.sigla_descricao ? " - " + item.sigla_descricao : null}
                                                                    </Typography>
                                                                    :
                                                                    null
                                                                }
                                                                {
                                                                    item?.descricao?.search('Próximos Passos:') === -1 ?
                                                                        <Typography
                                                                            style={{
                                                                                wordBreak: "break-word",
                                                                                padding: "10px",
                                                                                // boxShadow: "1px 0.5px 4px 0 rgb(0 0 0 / 10%), 0 3px 10px 0 rgb(0 0 0 / 9%)",
                                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                                fontSize: "13px"
                                                                            }}>
                                                                            {item?.descricao}
                                                                        </Typography>
                                                                        :
                                                                        <>
                                                                            <Typography
                                                                                style={{
                                                                                    wordBreak: "break-word",
                                                                                    padding: "10px",
                                                                                    // boxShadow: "1px 0.5px 4px 0 rgb(0 0 0 / 10%), 0 3px 10px 0 rgb(0 0 0 / 9%)",
                                                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                                                    fontSize: "13px"
                                                                                }}>
                                                                                {item?.descricao?.slice(0, item?.descricao.search('Próximos Passos:'))}
                                                                            </Typography>
                                                                            <Typography
                                                                                style={{
                                                                                    wordBreak: "break-word",
                                                                                    padding: "10px",
                                                                                    // boxShadow: "1px 0.5px 4px 0 rgb(0 0 0 / 10%), 0 3px 10px 0 rgb(0 0 0 / 9%)",
                                                                                    fontFamily: `${pallet.general.fontFamily}`,
                                                                                    fontSize: "13px"
                                                                                }}>
                                                                                {item?.descricao?.slice(item?.descricao.search('Próximos Passos:'), item.descricao.length)}
                                                                            </Typography>
                                                                        </>

                                                                }
                                                                {item.url ?
                                                                    <Typography
                                                                        style={{
                                                                            wordBreak: "break-word",
                                                                            padding: "10px",
                                                                            // boxShadow: "1px 0.5px 4px 0 rgb(0 0 0 / 10%), 0 3px 10px 0 rgb(0 0 0 / 9%)",
                                                                            fontFamily: `${pallet.general.fontFamily}`,
                                                                            fontSize: "13px"
                                                                        }}>
                                                                        {props.propCasa === 1 || props.propCasa === 3 ?

                                                                            <a href={helpers.extrairUrlCompleta(item.url.replace('http', 'https').replace('"}]', ''))} target='_blank'>{helpers.extrairUrlCompleta(item.url.replace('"}]', ''))}</a>
                                                                            :
                                                                            <a href={item.url} target='_blank'>{item.url}</a>



                                                                        }


                                                                    </Typography>

                                                                    : null}

                                                            </Grid>
                                                            <Grid>
                                                                <Grid className="container">
                                                                    <AnexosComponent
                                                                        label={''}
                                                                        modulo={EAnexoModulos.Tramitacao}
                                                                        id_referencia={item.id}
                                                                        canEdit={false}
                                                                        autosave={false}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </StepContent>
                                                </Step>
                                            )
                                        })}
                                    </Stepper>
                                </Box>
                    }

                    {
                        //(infoList?.totalItens > 0 && !infoList?.totalNoFilter) &&
                        tramitacoes.length > 0 &&

                        <Grid container justifyContent="center" style={{ marginTop: "40px", marginBottom: "40px", paddingBottom: `${isMobile ? "40px" : "0px"}` }}>

                            <Stack spacing={2}>
                                {/* <Pagination
                                    size={isMobile ? "small" : "large"}
                                    onChange={setPage}
                                    count={infoList?.totalPages}
                                    page={currentPage}
                                    shape="rounded"
                                /> */}
                                <PaginationSaveState
                                    //size={isMobile ? "small" : "large"}
                                    name={"ProposicaoTramitacaoListCurrentPage"}
                                    page={currentPage}
                                    pages={infoList?.totalPages}
                                    onChange={setCurrentPage}
                                //shape="rounded"
                                />
                            </Stack>

                        </Grid>
                    }

                </Grid>


            </div>
        </div>
    )
}
